import ListagemFornecedor from '@/modules/gestao-fornecedor/ListagemFornecedor.vue';
import FornecedorDetalhes from '@/modules/gestao-fornecedor/gestao/detalhes/FornecedorDetalhes.vue';

export default [
  {
    path: 'fornecedores',
    name: 'main.gestao-fornecedores.fornecedores',
    components: {
      default: ListagemFornecedor,
    },
  },
  {
    path: 'fornecedor/:id',
    name: 'main.gestao-fornecedores.fornecedor',
    components: {
      default: FornecedorDetalhes,
    },
  },
];
